import { apiProxyRequest } from "Api/apiProxyRequest";
import { resolveIfHasLink } from "Api/utils";

import type { BillingUsersResponse } from "../types";
import type { RefUser } from "Api/ref/User.types";

type RefUserResponse = { [userId: string]: RefUser };

export const getBillingUsersRequest = (billingProfileId: string) => {
  return apiProxyRequest<BillingUsersResponse>(
    `/billing/profiles/${billingProfileId}/users`
  );
};

// Iterates every `ref:users:N` link and merges the fulfilled responses, so a
// single failing page doesn't drop the rest of the resolved users.
export const resolveBillingUsersLinks = (
  billingUsers: BillingUsersResponse
) => ({
  users: resolveIfHasLink(billingUsers, "ref:users:0", async () => {
    const links = billingUsers._links as Record<string, { href: string }>;
    const refUserHrefs = Object.keys(links)
      .filter(key => key.startsWith("ref:users:"))
      .map(key => links[key].href);

    const results = await Promise.allSettled(
      refUserHrefs.map(href => apiProxyRequest<RefUserResponse>(href))
    );

    return results.reduce<RefUserResponse>(
      (acc, result) =>
        result.status === "fulfilled" ? { ...acc, ...result.value } : acc,
      {}
    );
  })
});
